import React, { useState, useEffect } from "react";
import InView from "react-intersection-observer";
import Slider from 'react-slick';
import IconChatPatient from "../../icons/icon-chat-patient.svg";
import IconMeasureProgress from "../../icons/icon-measure-progress.svg";
import IconSendExercises from "../../icons/icon-send-exercises.svg";
import IconMeasurePain from "../../icons/icon-measure-pain.svg";
import ImageDay1 from "../../images/screen-day-1.png";
import ImageDay2 from "../../images/screen-day-2.png";
import ImageDay3 from "../../images/screen-day-3.png";
import ImageDay4 from "../../images/screen-day-4.png";
import ImageHomeExercise1 from "../../images/exercise-img-1.png";
import ImageHomeExercise2 from "../../images/exercise-img-2.png";
import ImageHomeExercise3 from "../../images/exercise-img-3.png";
import ImageHomeExercise4 from "../../images/exercise-img-4.png";
import ImageHomeExercise5 from "../../images/exercise-img-5.png";
import ImageHomeExercise6 from "../../images/exercise-img-6.png";
import ImageHomeExercise7 from "../../images/exercise-img-7.png";
import ImageHomeExercise8 from "../../images/exercise-img-8.png";
import ImageHomeExercise9 from "../../images/exercise-img-9.png";
import ImageHomeExercise10 from "../../images/exercise-img-10.png";
import ImageHomeExercise11 from "../../images/exercise-img-11.png";
import LazyLoad from 'react-lazyload';
import Parallax from "../common/utils/animations/parallax";
//import AOS from 'aos';
import 'aos/dist/aos.css'

export default function Intro() {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  let slider1 = null;
  let slider2 = null;

  let AOS;

  useEffect(() => {
    const AOS = require("aos");
    AOS.init({
      once: true,
    });
    setNav1(slider1);
    setNav2(slider2);
  }, []);

  useEffect(() => {
    if (AOS) {
      AOS.refresh();
    }    
  });

  const settings = {
      responsive: [
        {
          breakpoint: 1201,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 3,
            centerMode: true,
            centerPadding: '0px'
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            centerMode: true,
            centerPadding: '0px'
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '0px'
          }
        },
        {
          breakpoint: 0,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    };
  return (
    <InView>
      <div className="section-gap-large po-progress-section">
        <div className="po-progress-content section-gap-small">
          <div className="container-small">
            <div className="intro-inner">
              <h3 className="h3">Deciphering pain and progress</h3>
              <p>We knew that providers, especially doctors, only need to engage if the patient is in pain and does not report expected progress, typically measured as Patient Reported Outcomes (P.R.O). For various injuries and conditions, the P.R.O surveys, formulas, and standards are entirely different. We wanted to automate it. So, we built a native survey engine to create custom P.R.Os and a formula designer to score patients' conditions from survey responses.</p>

              <p>The platform asks patients to regularly take the P.R.O surveys as part of the automated pathways, i.e., reporting their progress or pains. If the patient needs intervention, doctors are automatically informed to engage. </p>

            </div>
          </div>
        </div>
        <div className="po-progress-slider section-gap">
          
              <div className="progress-icon-slider section-gap">
              <div className="container-small">
                <Slider
                    asNavFor={nav2}
                    ref={slider => (slider1 = slider)}
                    //infinite={true}
                    arrows={false}
                    swipe={false}
                    cssEase={'linear'}
                    autoplaySpeed= {4000}
                    autoplay= {true}  
                    slidesToShow={4}
                    slidesToScroll={1}
                    focusOnSelect={true}
                    >
                    <div>
                      <span className="day-count">Day 1</span>
                      <div className="progress-icon">
                         <IconMeasureProgress />
                      </div>
                      <span className="day-title">Send Exercises</span>
                    </div>
                    <div>
                      <span className="day-count">Day 2</span>
                      <div className="progress-icon">
                        <IconMeasurePain />
                      </div>
                      <span className="day-title">Measure Pain</span>
                    </div>
                    <div>
                      <span className="day-count">Day 3</span>
                      <div className="progress-icon">
                        <IconChatPatient />
                      </div>
                      <span className="day-title">Chat with Patient</span>
                    </div>
                    <div>
                      <span className="day-count">Day 4</span>
                      <div className="progress-icon">
                        <IconSendExercises />
                      </div>
                      <span className="day-title">Measure Progress</span>
                    </div>
                </Slider>
              </div>
            </div>
            <div className="progress-image-slider">
              <div className="container">
                <Slider
                  asNavFor={nav1}
                  ref={slider => (slider2 = slider)}
                  arrows={false}
                  infinite={true}
                  slidesToShow={4}
                  slidesToScroll={1}
                  swipe={false}
                  focusOnSelect={true}
                  {...settings} 
                  >
                      <div data-aos="zoom-in"><img src={ImageDay1} title="Chat window" alt="Chat window" /></div>
                      <div data-aos="zoom-in"><img src={ImageDay2} title=" P.R.O" alt="patient reported outcome" /></div>
                      <div data-aos="zoom-in"><img src={ImageDay3} title="Contacts" alt="Contacts" /></div>
                      <div data-aos="zoom-in"><img src={ImageDay4} title="Exercise scheduling" alt="Exercise scheduling" /></div>
                </Slider>
              </div>
            </div>
          </div>

          <div className="po-home-exercise">
            <div className="container">
              <div className="po-home-exercise-content">
                  <h3>Tracking home exercise compliance</h3>
                  <p>
                  It was crucial for providers to know that patients are "actually" following their routines and exercises regularly and adequately. When they are away, the only way to ensure that is to track patients' interactions. Hence, we implemented complex yet intelligent features that track patients' behavior and interactions. In response, the system can trigger tailored messages, notifications, and surveys to track the recovery progress. We also designed the real-time patient chart that offers a 360 view of their progress and recovery so far.
                  </p>
              </div>

            <div className="po-home-exercise-images">
              <div data-aos="zoom-in" data-aos-delay="50"><Parallax classes="exercise-image-1" id="exercise-image-1" triggers={[1, 0.6]} length={50}><LazyLoad offset={500}><img src={ImageHomeExercise1} title="Exercise" alt="Exercise" /></LazyLoad></Parallax></div>
              <div data-aos="zoom-in" data-aos-delay="100"><Parallax classes="exercise-image-2" id="exercise-image-2" triggers={[1, 0.6]} length={50}><LazyLoad offset={500}><img src={ImageHomeExercise2} title="Dropdown menu" alt="Dropdown menu" /></LazyLoad></Parallax></div>
              <div data-aos="zoom-in" data-aos-delay="150"><Parallax classes="exercise-image-3" id="exercise-image-3" triggers={[1, 0.6]} length={50}><LazyLoad offset={500}><img src={ImageHomeExercise3} title="Connections" alt="Connections" /></LazyLoad></Parallax></div>
              <div data-aos="zoom-in" data-aos-delay="200"><Parallax classes="exercise-image-4" id="exercise-image-4" triggers={[1, 0.6]} length={50}><LazyLoad offset={500}><img src={ImageHomeExercise4} title="Status tracker" alt="Status tracker" /></LazyLoad></Parallax></div>
              <div data-aos="zoom-in" data-aos-delay="250"><Parallax classes="exercise-image-5" id="exercise-image-5" triggers={[1, 0.6]} length={100}><LazyLoad offset={500}><img src={ImageHomeExercise5} title="Exercises" alt="Exercises" /></LazyLoad></Parallax></div>
              <div data-aos="zoom-in" data-aos-delay="300"><Parallax classes="exercise-image-6" id="exercise-image-6" triggers={[1, 0.6]} length={100}><LazyLoad offset={500}><img src={ImageHomeExercise6} title="Documents" alt="Documents" /></LazyLoad></Parallax></div>
              <div data-aos="zoom-in" data-aos-delay="350"><Parallax classes="exercise-image-7" id="exercise-image-7" triggers={[1, 0.6]} length={100}><LazyLoad offset={500}><img src={ImageHomeExercise7} title="Video tutorials" alt="Video tutorials" /></LazyLoad></Parallax></div>
              <div data-aos="zoom-in" data-aos-delay="400"><Parallax classes="exercise-image-8" id="exercise-image-8" triggers={[1, 0.6]} length={100}><LazyLoad offset={500}><img src={ImageHomeExercise8} title="sorting options" alt="sorting options" /></LazyLoad></Parallax></div>
              <div data-aos="zoom-in" data-aos-delay="450"><Parallax classes="exercise-image-9" id="exercise-image-9" triggers={[1, 0.6]} length={100}><LazyLoad offset={500}><img src={ImageHomeExercise9} title=" P.R.O tracking" alt=" P.R.O tracking" /></LazyLoad></Parallax></div>
              <div data-aos="zoom-in" data-aos-delay="500"><Parallax classes="exercise-image-10" id="exercise-image-10" triggers={[1, 0.6]} length={100}><LazyLoad offset={500}><img src={ImageHomeExercise10} title="Progress tracker" alt="Progress tracker" /></LazyLoad></Parallax></div>
              <div data-aos="zoom-in" data-aos-delay="550"><Parallax classes="exercise-image-11" id="exercise-image-11" triggers={[1, 0.6]} length={100}><LazyLoad offset={500}><img src={ImageHomeExercise11} title="Activity logs" alt="Activity logs" /></LazyLoad></Parallax></div>
            </div>
            </div>
          </div>
        </div>
    </InView>
  );
}
